var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccountIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "account_circle"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2200_2757",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    y: 0.5,
    width: 24,
    height: 24
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2200_2757)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "account_circle_2",
    d: "M5.85 17.6C6.7 16.95 7.65 16.4375 8.7 16.0625C9.75 15.6875 10.85 15.5 12 15.5C13.15 15.5 14.25 15.6875 15.3 16.0625C16.35 16.4375 17.3 16.95 18.15 17.6C18.7333 16.9167 19.1875 16.1417 19.5125 15.275C19.8375 14.4083 20 13.4833 20 12.5C20 10.2833 19.2208 8.39583 17.6625 6.8375C16.1042 5.27917 14.2167 4.5 12 4.5C9.78333 4.5 7.89583 5.27917 6.3375 6.8375C4.77917 8.39583 4 10.2833 4 12.5C4 13.4833 4.1625 14.4083 4.4875 15.275C4.8125 16.1417 5.26667 16.9167 5.85 17.6ZM12 13.5C11.0167 13.5 10.1875 13.1625 9.5125 12.4875C8.8375 11.8125 8.5 10.9833 8.5 10C8.5 9.01667 8.8375 8.1875 9.5125 7.5125C10.1875 6.8375 11.0167 6.5 12 6.5C12.9833 6.5 13.8125 6.8375 14.4875 7.5125C15.1625 8.1875 15.5 9.01667 15.5 10C15.5 10.9833 15.1625 11.8125 14.4875 12.4875C13.8125 13.1625 12.9833 13.5 12 13.5ZM12 22.5C10.6167 22.5 9.31667 22.2375 8.1 21.7125C6.88333 21.1875 5.825 20.475 4.925 19.575C4.025 18.675 3.3125 17.6167 2.7875 16.4C2.2625 15.1833 2 13.8833 2 12.5C2 11.1167 2.2625 9.81667 2.7875 8.6C3.3125 7.38333 4.025 6.325 4.925 5.425C5.825 4.525 6.88333 3.8125 8.1 3.2875C9.31667 2.7625 10.6167 2.5 12 2.5C13.3833 2.5 14.6833 2.7625 15.9 3.2875C17.1167 3.8125 18.175 4.525 19.075 5.425C19.975 6.325 20.6875 7.38333 21.2125 8.6C21.7375 9.81667 22 11.1167 22 12.5C22 13.8833 21.7375 15.1833 21.2125 16.4C20.6875 17.6167 19.975 18.675 19.075 19.575C18.175 20.475 17.1167 21.1875 15.9 21.7125C14.6833 22.2375 13.3833 22.5 12 22.5Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountIcon);
export default __webpack_public_path__ + "static/media/AccountIcon.5a993fae0a63ba71729ca477a6f924a8.svg";
export { ForwardRef as ReactComponent };